module.exports = __webpack_public_path__ + "img/ic_upload_fail.dc58d2a9.svg";